export default {
      id: "video-event_right-turn-usage",
      viewBox: "0 0 15 20",
      url: __webpack_public_path__ + "img/icons.svg#video-event_right-turn",
      toString: function () {
        return this.url;
      }
    }